import { module } from "angular";
import { FeatureFlagComponent } from "./FeatureSwitcherComponent";

module("mmGui").component("irFeatureSwitcher", new FeatureFlagComponent());
